
import { formatDate, formatNumber } from '@/lib/filters'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    data: {},
    title: { default: 'Naziv pogodbe' }
  },
  setup() {
    return { formatDate, formatNumber }
  }
})
